<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card>
      <v-card-title class="text-h5 grey lighten-4">
        お知らせ登録
      </v-card-title>
      <v-card-text class="pt-3 pb-0">
        <v-textarea
          v-model="privateMessage"
          label="職員向け"
          v-bind="textareaProps"
        />
        <v-textarea
          v-model="publicMessage"
          label="一般向け"
          v-bind="textareaProps"
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">
          閉じる
        </v-btn>
        <v-btn color="primary" @click="save">
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      color="green"
      :style="{ fontSize: '14px' }"
    >
      {{ snackbarMessage }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import AWS from "aws-sdk";
import { cognitoConfig } from "../config";
import * as cognito from "../utils/cognito";
import { isPrivateMode } from "../utils/common";

const Bucket = "ctie.tamura.web";
const MessagesKey = "system/messages.json";

export default {
  name: "SystemMessageEditor",
  data() {
    return {
      dialog: false,
      privateMessage: "現在、お知らせはありません。",
      publicMessage: "現在、お知らせはありません。",
      textareaProps: {
        outlined: true,
        rows: 6,
        style: {
          fontSize: "14px"
        }
      },
      s3: null,
      snackbar: false,
      snackbarMessage: "保存しました。"
    };
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    async open(newVal) {
      this.dialog = newVal;
      if (newVal === true) {
        this.openInit();
      }
    }
  },
  computed: {
    //
  },
  async mounted() {
    //
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$emit("close");
    },
    async openInit() {
      if (this.s3 !== null) {
        this.getMessages();
      }

      const credentials = await cognito.getCredentials();
      credentials.get(err => {
        if (err) {
          console.error("Failed to get credentials:");
          return;
        }
        this.s3 = new AWS.S3({
          credentials: credentials
        });
        this.getMessages();
      });
    },
    async getMessages() {
      if (this.s3 === null) return;
      const requestParams = {
        Bucket: Bucket,
        Key: MessagesKey
      };
      const res = await this.s3.getObject(requestParams).promise();
      const data = JSON.parse(res.Body.toString("utf-8"));
      this.privateMessage = data.private;
      this.publicMessage = data.public;
    },
    async save() {
      if (this.s3 === null) return;
      if (this.$store.getters.isPrivateAdministrator !== true) {
        alert("この機能は管理者のみが利用できます。");
        return;
      }
      console.log("save");
      const data = {
        private: this.privateMessage,
        public: this.publicMessage
      };
      AWS.config.region = cognitoConfig.Region;
      const requestParams = {
        Bucket: Bucket,
        Key: MessagesKey,
        Body: JSON.stringify(data)
      };
      const res = await this.s3.putObject(requestParams).promise();
      console.log(res.$response.httpResponse.statusCode);
      if (res.$response.httpResponse.statusCode !== 200) {
        this.snackbarMessage = "保存に失敗しました。";
        this.snackbar = true;
      } else {
        const message = isPrivateMode
          ? this.privateMessage
          : this.publicMessage;
        this.$store.commit("SET_SYSTEM_MESSAGE", message);
        this.snackbarMessage = "保存しました。";
        this.snackbar = true;
        this.closeDialog();
      }
    }
  }
};
</script>
